import * as React from 'react';
/**
 *
 * Original name: search
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A312
 *
 */
export const SearchPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M27 16v4c4.775 0 7 2.225 7 7h4c0-6.99-4.01-11-11-11Z", fill: "currentColor" }),
    React.createElement("path", { d: "M55.414 52.586 42.4 39.572C44.761 36.444 46 32.228 46 27c0-12.252-6.748-19-19-19C14.748 8 8 14.748 8 27c0 12.252 6.748 19 19 19 5.228 0 9.444-1.239 12.572-3.6l13.014 13.014 2.828-2.828ZM27 42c-10.094 0-15-4.906-15-15 0-10.094 4.906-15 15-15 10.094 0 15 4.906 15 15 0 10.094-4.906 15-15 15Z", fill: "currentColor" })));
